/** @jsx jsx */
import { css, jsx, SerializedStyles } from '@emotion/core';
import { Grid, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';

import { ICustomTheme } from 'interfaces';

const cssButton = (theme: ICustomTheme): SerializedStyles =>
  css({
    marginTop: theme.spacing(3),
  });
const cssName = (theme: ICustomTheme): SerializedStyles =>
  css({
    marginTop: theme.spacing(2),
  });
const cssVotes = (theme: ICustomTheme): SerializedStyles =>
  css({
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
  });

const PhotoBlockSkeleton = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Grid
      item
      xs={12}
      md={6}
      lg={4}
      css={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}
    >
      <Skeleton
        variant="circle"
        height={296}
        width={296}
        css={{ minWidth: 296 }}
      />
      <Skeleton variant="circle" height={48} width={48} css={cssButton} />
      <Skeleton css={cssName}>
        <Typography>
          {t('photo_contest.rank.photo_bloc_skeleton_participant')}
        </Typography>
      </Skeleton>
      <Skeleton css={cssVotes}>
        <Typography variant="h2">
          {t('photo_contest.rank.photo_bloc_skeleton_votes')}
        </Typography>
      </Skeleton>
    </Grid>
  );
};

export default PhotoBlockSkeleton;
